var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "styled-components";
import { getValidatedControlColor } from "../theme";
export var controlFocused = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-color: ", ";\n  box-shadow: 0 0 0 1px ", ";\n"], ["\n  border-color: ", ";\n  box-shadow: 0 0 0 1px ", ";\n"])), getValidatedControlColor("controlFocused"), getValidatedControlColor("controlFocused"));
var templateObject_1;
